import React, { FC } from 'react';
import classNames from 'classnames';
import key from 'weak-key';
import VPOption, { VPOptionProps } from '@/pages/MarketReportsListingPage/components/VPOption/VPOption';
import grid from '@/common/css/grid.module.scss';
import styles from './VPSection.module.scss';

interface VPSectionProps {
  options: VPOptionProps[];
}

const VPSection: FC<VPSectionProps> = ({
  options,
}: VPSectionProps) => {
  if (!options?.length) {
    return null;
  }

  const optionsView = options.map((option) => (
    <VPOption
      key={key(option)}
      title={option.title}
      description={option.description}
      className={styles.option}
    />
  ));

  return (
    <div className={grid.row}>
      <div className={classNames(styles.wrapper, grid.colSm10, grid.offsetSm1)}>
        {optionsView}
      </div>
    </div>
  );
};

export default VPSection;
